export default __webpack_public_path__ + "static/media/misc-pantry2-480w.a3f2b209.avif";